// extracted by mini-css-extract-plugin
export default {"producemarket":"producemarket_f20abe83c7868d2d2085","name":"name_d91fb5a4950859d20b54"};